import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import moment from 'moment'

import {imageType} from '../../../utils/commonPropTypes'
import WidthContainer from '../../../components/WidthContainer'
import {QueriedGatsbyImage} from '../../../components/GatsbyImage'

const RootContainer = styled(WidthContainer)`
	max-width: ${props => props.theme.smallerWidth};
`

const AboveTitle = styled.div`
	font-size: ${props => props.theme.fontSizes.big20};
	font-weight: ${props => props.theme.fontWeights.medium};
	margin-bottom: 1rem;
`

const Title = styled.h1`
	margin-bottom: 2.25rem;
`

const IntroText = styled.p`
	margin-bottom: 1.875rem;
`

const MetaContainer = styled.div`
	display: flex;
	font-size: ${props => props.theme.fontSizes.smallest};
	align-items: center;
	margin-bottom: 2.243rem;
	flex-wrap: wrap;
`

const AuthorName = styled.div`
	font-weight: ${props => props.theme.fontWeights.bold};
	margin: 0 1.8rem 0 1.25rem;
`
const AuthorImage = styled(QueriedGatsbyImage)`
	width: 3rem !important;
	height: 3rem !important;
	border-radius: 1.5rem;
`

const Date = styled.div`
`

const ArticleIntro = ({className, data}) => <RootContainer className={className}>
	<AboveTitle>{data.aboveTitle}</AboveTitle>
	<Title>{data.title}</Title>
	<IntroText>{data.intro}</IntroText>
	<MetaContainer>
		{!!data.author && <>
			<AuthorImage image={data.author.photo}/>
			<AuthorName>{data.author.name}</AuthorName>
		</>}
		<Date>{moment(data.createdAt).format('MMMM D, YYYY')}</Date>
	</MetaContainer>
</RootContainer>

ArticleIntro.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		aboveTitle: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
		intro: PropTypes.string.isRequired,
		author: PropTypes.shape({
			name: PropTypes.string.isRequired,
			photo: imageType.isRequired,
		}).isRequired,
		createdAt: PropTypes.string.isRequired,
	}),
}

ArticleIntro.defaultProps = {
	className: '',
}

export default ArticleIntro
